import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export function Spinner() {
  return (
    <Rotate>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20'
          stroke='url(#paint0_linear_5075_5905)'
          strokeWidth='2'
          strokeLinecap='round'
        />
        <path
          d='M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.4571 19.6104 14.8233 18.9297 16'
          stroke='url(#paint1_linear_5075_5905)'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <defs>
          <linearGradient
            id='paint0_linear_5075_5905'
            x1='8'
            y1='20'
            x2='20.5'
            y2='15.5'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#81898F' />
            <stop offset='0.382331' stopColor='#81898F' />
            <stop offset='0.818132' stopColor='#81898F' stopOpacity='0.36' />
            <stop offset='1' stopColor='#81898F' stopOpacity='0' />
          </linearGradient>
          <linearGradient
            id='paint1_linear_5075_5905'
            x1='18'
            y1='-4.5'
            x2='11'
            y2='17'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#81898F' />
            <stop
              offset='0.703125'
              stopColor='#81898F'
              stopOpacity='0.208333'
            />
            <stop offset='0.848958' stopColor='#81898F' stopOpacity='0' />
            <stop offset='1' stopColor='#81898F' stopOpacity='0' />
          </linearGradient>
        </defs>
      </svg>
    </Rotate>
  );
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Rotate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${spin} 1.2s linear infinite;
`;
